import { useState } from "react"

// Ergebnis- und Signalzustand der Routenberechnung (Pathfinder, Erklärbär,
// ETA-Fehler, Voyage-Refresh).
export function usePathfinderState() {
  const [pathfinderResponse, setPathfinderResponse] = useState(null)
  const [erklaerbaerEnabled, setErklaerbaerEnabled] = useState(false)
  const [erklaerbaerId, setErklaerbaerId] = useState(null)
  const [etaError, setEtaError] = useState(null)
  const [voyageRefreshSignal, setVoyageRefreshSignal] = useState(0)

  return {
    pathfinderResponse,
    setPathfinderResponse,
    erklaerbaerEnabled,
    setErklaerbaerEnabled,
    erklaerbaerId,
    setErklaerbaerId,
    etaError,
    setEtaError,
    voyageRefreshSignal,
    setVoyageRefreshSignal,
  }
}
